// © Microsoft Corporation. All rights reserved.

import { DesignSystem, HighContrastColor, accentFillRest, highContrastSelector, isDarkMode, neutralFillActive, neutralFillHover, neutralFillToggleHover, neutralForegroundHint, neutralForegroundRest } from "@microsoft/fast-components-styles-msft";

import { applyLocalizedProperty } from "@microsoft/fast-jss-utilities";
import { enums } from "../../utils/enums";

const leftRightPadding = "15px";
export const ContentPanelStyles = (config: DesignSystem) => ({
    contentPanelContainer: {
        margin: `-15px -${leftRightPadding} 0px -${leftRightPadding}`,
        "scroll-margin-top": "150px",

        "& .cwt-content-panel-header": {
            display: "flex",
            "justify-content": "space-between",
            color: neutralForegroundHint,
            "border-bottom": "1px solid #F1F1F1",
            "border-color": neutralFillActive,
            padding: `15px ${leftRightPadding} 18px ${leftRightPadding}`,
            "& .cwt-title": {
                margin: "3.2px 0",
                "font-size": "24px",
                "font-weight": "bold",
                color: neutralForegroundRest
            },

            "& .cwt-sub-title": {
                margin: "0 8px",
                "font-size": "13px",
                "vertical-align": "text-bottom"
            }
        },
        "& .cwt-beta-badge": {
            display: "inline-block",
            padding: "4.8px",
            "font-size": "10px",
            "font-weight": "bold",
            "line-height": "1em",
            background: neutralFillHover,
            color: neutralForegroundRest,
            "letter-spacing": applyLocalizedProperty("-.01em", "0", config.direction),
            "border-radius": "4px",
            height: "1em"
        },
        "& .cwt-guideline-section": {
            padding: `12px ${leftRightPadding} 22px ${leftRightPadding}`,
            display: "flex",
            "justify-content": "space-between",
            "& .cwt-main-typing-indicator": {
                height: "22px",
                "min-width": "60px"
            }
        },
        "& .cwt-content-panel-content": {
            padding: `16px ${leftRightPadding} 0px ${leftRightPadding}`,
            "& .cwt-title": {
                "font-size": "20px",
                "font-weight": "600",
                color: neutralForegroundRest,

                "& .cwt-comment-count": {
                    "font-weight": "normal",
                    color: neutralFillToggleHover
                }
            }
        },
        "& .cwt-content-panel-footer": {
            "& .cwt-guidelines-message": {
                "font-size": "13px",
                color: neutralForegroundHint,

                "& .cwt-link": {
                    color: isDarkMode(config) ? "#5CB6FF" : accentFillRest
                }
            }
        }
    },

    contentPanelZeroStateContainer: {
        margin: `-${leftRightPadding}`,
        "& .cwt-content-panel-header": {
            margin: "0px",
            border: "0px"
        }
    },

    contentPanelMinimalStateContainer: {
        position: "absolute",
        [applyLocalizedProperty("right", "left", config.direction)]: "16px",
        top: "14px",
        display: "flex",
        "scroll-margin-top": "150px",
        "& .cwt-beta-badge": {
            display: "inline-block",
            padding: "4.8px",
            "font-size": "10px",
            "font-weight": "bold",
            "line-height": "1em",
            background: neutralFillActive,
            color: neutralForegroundRest,
            "letter-spacing": applyLocalizedProperty("-.01em", "0", config.direction),
            "border-radius": "4px",
            height: "1em"
        }
    },
    contentPanelOverlayContainer: {
        "& .cwt-beta-badge": {
            display: "none"
        }
    }
});